const removeTabActiveClass = (parentElem) => {
  const navLinks = parentElem.querySelectorAll('.date-picker__nav-link.is-active');
  const tabPanels = parentElem.querySelectorAll('.date-picker__tabpanel.is-active');
  const activeItems = [...navLinks, ...tabPanels];
  activeItems.forEach((elem) => {
    elem.classList.remove('is-active');
  });
};

attachEvent('.date-picker__nav-link', 'click', (ev) => {
  const button = ev.target;
  const parentElem = button.closest('.date-picker');
  const tabId = button.getAttribute('aria-controls');
  const panelElement = parentElem.querySelector(`#${tabId}`);
  removeTabActiveClass(parentElem);
  button.classList.add('is-active');
  panelElement.classList.add('is-active');
  ev.preventDefault();
});

mobiscroll.setOptions({
  theme: 'ios',
  themeVariant: 'light',
});

// eslint-disable-next-line no-unused-vars
const mobiscrollEl = mobiscroll.datepicker('#booking-single', localData.calendar);
